(function () {
  function initialize() {
    document.querySelectorAll('[data-books-navigation]').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      var categories = Array.from(root.querySelectorAll('.books-category'));
      function toggle(item, open) {
        item.classList.toggle('is-open', open);
        var button = item.querySelector(':scope > button');
        if (button) button.setAttribute('aria-expanded', String(open));
        if (item === root && !open) categories.forEach(function (category) { toggle(category, false); });
      }
      function openCategory(category) {
        categories.forEach(function (item) { toggle(item, item === category); });
      }
      [root].concat(categories).forEach(function (item) {
        var button = item.querySelector(':scope > button');
        if (button) button.addEventListener('click', function () {
          var open = !item.classList.contains('is-open');
          if (item !== root && open) openCategory(item);
          else toggle(item, open);
        });
        item.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse') return;
          if (item === root) toggle(root, true);
          else openCategory(item);
        });
        item.addEventListener('pointerleave', function () {
          if (!item.contains(document.activeElement)) toggle(item, false);
        });
      });
      root.addEventListener('focusin', function (event) {
        if (event.target.tagName === 'BUTTON') return;
        toggle(root, true);
        var category = event.target.closest('.books-category');
        if (category) openCategory(category);
      });
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) toggle(root, false);
      });
      root.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        var category = event.target.closest('.books-category.is-open');
        var item = category || root;
        toggle(item, false);
        item.querySelector(':scope > button').focus();
      });
      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) toggle(root, false);
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
